var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLessonDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4297,
    cy: 12,
    r: 12,
    fill: "#838383"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9297 18C14.9297 18.1326 14.877 18.2598 14.7832 18.3535C14.6895 18.4473 14.5623 18.5 14.4297 18.5H10.4297C10.2971 18.5 10.1699 18.4473 10.0761 18.3536C9.98237 18.2598 9.92969 18.1326 9.92969 18C9.92969 17.8674 9.98237 17.7402 10.0761 17.6464C10.1699 17.5527 10.2971 17.5 10.4297 17.5H14.4297C14.5623 17.5 14.6895 17.5527 14.7832 17.6465C14.877 17.7402 14.9297 17.8674 14.9297 18V18ZM18.9297 8V15C18.9292 15.3977 18.7711 15.779 18.4898 16.0602C18.2086 16.3414 17.8274 16.4995 17.4297 16.5H7.42969C7.032 16.4995 6.65074 16.3414 6.36953 16.0602C6.08832 15.779 5.93014 15.3977 5.92969 15V8C5.93014 7.60231 6.08832 7.22105 6.36953 6.93984C6.65074 6.65864 7.032 6.50045 7.42969 6.5H17.4297C17.8274 6.50045 18.2086 6.65864 18.4898 6.93984C18.7711 7.22105 18.9292 7.60231 18.9297 8V8ZM14.9297 11.5C14.9296 11.4177 14.9092 11.3367 14.8704 11.2641C14.8315 11.1916 14.7754 11.1297 14.707 11.084L11.707 9.08397C11.6318 9.03368 11.5442 9.00479 11.4538 9.00038C11.3634 8.99597 11.2735 9.0162 11.1936 9.05892C11.1138 9.10164 11.0471 9.16523 11.0006 9.24292C10.9541 9.3206 10.9296 9.40945 10.9297 9.49998V13.5C10.9297 13.5905 10.9542 13.6793 11.0008 13.7569C11.0473 13.8346 11.114 13.8981 11.1938 13.9408C11.2735 13.9835 11.3634 14.0038 11.4538 13.9994C11.5442 13.995 11.6317 13.9662 11.707 13.916L14.707 11.916C14.7754 11.8703 14.8315 11.8084 14.8704 11.7358C14.9092 11.6633 14.9296 11.5823 14.9297 11.5V11.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonDisable);
export default __webpack_public_path__ + "static/media/lesson_disable.f17d3b89.svg";
export { ForwardRef as ReactComponent };